/* global markers google */
import GMaps from 'gmaps/gmaps.min';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //map for hero - varibles set in footer.php
    var heroMap = new GMaps({
      div: '.hero-map',
      gestureHandling: 'cooperative',
      lat: 54.97711, //Redman location (just for a default as the mark markers set location and zoom)
      lng: -1.495904,
    });

    var bounds = []; //object to hold map marker in

    for (var marker in markers) { //object markers created in footer.php
      if (markers.hasOwnProperty(marker)) {
        var markerInfo = markers[marker];

        var latlng = new google.maps.LatLng(markerInfo.latitude, markerInfo.longitude); //location of map marker - that extra bit of latitude is to offset the map center to allow for the menu sitting over the map
        bounds.push(latlng); //adds this marker to the bounds object

        //populate footer map with the markers
        heroMap.addMarker({
          lat: markerInfo.latitude,
          lng: markerInfo.longitude,
          title: markerInfo.title,
          infoWindow: {
            content: '<h5>' + markerInfo.title + '</h5>' + markerInfo.description,
          },
        });

      }
    }

      if(heroMap.markers.length > 1){ //see how many map markers
        heroMap.fitLatLngBounds(bounds); // Fit All Marker to map from the bounds object
      }else{
        heroMap.panTo(heroMap.markers[0].getPosition()); // only one marker, center it
        heroMap.setZoom(14);
      }


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js